import { useEffect, useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Modal, Form, Row, Col, message, Input } from "antd";
import { handleUpdateVehiclePrice } from "../../../../api/vehicles";
import roundUSD from "../../../../utils/roundUSD";
import roundRawUSD from "../../../../utils/roundRawUSD";

export default function UpdatePrice({
  isVisible,
  setVisible,
  vehicle,
  chassis,
}: any) {
  const [inclusive, setInclusive] = useState<number>(0);
  const [exclusive, setExclusive] = useState<number>(0);
  const queryClient = useQueryClient();
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation({
    mutationFn: handleUpdateVehiclePrice,
    onSuccess: () => {
      message.success("Updated Successfully");
      form.resetFields();
      queryClient.invalidateQueries({ queryKey: ["vehicles", chassis] });
    },
    onError: () => {
      message.error("Something went wrong");
    },
  });

  const onSubmit = async () => {
    const { exclusive, inclusive } = await form.getFieldsValue();
    const rawIn = roundRawUSD(inclusive);
    const rawEx = roundRawUSD(exclusive);
    const data = {
      price: {
        exclusive: rawEx,
        inclusive: rawIn,
      },
    };
    await mutate({ data, chassis });
    setVisible(false);
  };

  const clearForm = async () => {
    form.resetFields();
    setInclusive(0);
    setExclusive(0);
  };

  useEffect(() => {
    form.setFieldsValue({ ...vehicle });
  }, [vehicle]);

  return (
    <Modal
      open={isVisible}
      title="Update Price"
      onCancel={() => setVisible(false)}
      footer={[
        <Button danger key="back" onClick={clearForm}>
          Clear
        </Button>,
        <Button
          key="submit"
          form="updateVehiclePrice"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          loading={isLoading}
          danger
        >
          Submit
        </Button>,
      ]}
    >
      <Form
        id="updateVehiclePrice"
        form={form}
        name="normal_login"
        className="login-form"
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 0]}>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="inclusive"
              label="Price Inclusive ( USD )"
              rules={[
                {
                  required: true,
                  message: "Please enter Inclusive",
                },
              ]}
            >
              <Input
                type="number"
                onChange={(e: any) => {
                  setInclusive(e.target.value);
                  form.setFieldsValue({ exclusive: e.target.value / 1.18 });
                  setExclusive(e.target.value / 1.18);
                }}
                placeholder="Price Inclusive"
              />
            </Form.Item>
            <div className="">~ {roundUSD(inclusive)}</div>
          </Col>
          <Col xs={{ span: 24 }} lg={{ span: 12 }}>
            <Form.Item
              name="exclusive"
              label="Price Exclusive ( USD )"
              rules={[
                {
                  required: false,
                  message: "Please enter Exclusive",
                },
              ]}
            >
              <Input
                type="number"
                onChange={(e: any) => setExclusive(e.target.value)}
                placeholder="Price Exclusive"
              />
            </Form.Item>
            <div className="">~ {roundUSD(exclusive)}</div>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}
